export const MY_QUIZ_LIST_REQUEST = 'MY_QUIZ_LIST_REQUEST'
export const MY_QUIZ_LIST_SUCCESS = 'MY_QUIZ_LIST_SUCCESS'
export const MY_QUIZ_LIST_FAIL = 'MY_QUIZ_LIST_FAIL'

export const QUIZ_DETAILS_REQUEST = 'QUIZ_DETAILS_REQUEST'
export const QUIZ_DETAILS_SUCCESS = 'QUIZ_DETAILS_SUCCESS'
export const QUIZ_DETAILS_FAIL = 'QUIZ_DETAILS_FAIL'

export const QUIZ_CREATE_REQUEST = 'QUIZ_CREATE_REQUEST'
export const QUIZ_CREATE_SUCCESS = 'QUIZ_CREATE_SUCCESS'
export const QUIZ_CREATE_FAIL = 'QUIZ_CREATE_FAIL'
export const QUIZ_CREATE_RESET = 'QUIZ_CREATE_RESET'

export const QUIZ_LIST_REQUEST = 'QUIZ_LIST_REQUEST'
export const QUIZ_LIST_SUCCESS = 'QUIZ_LIST_SUCCESS'
export const QUIZ_LIST_FAIL = 'QUIZ_LIST_FAIL'

export const QUIZ_DELETE_REQUEST = 'QUIZ_DELETE_REQUEST'
export const QUIZ_DELETE_SUCCESS = 'QUIZ_DELETE_SUCCESS'
export const QUIZ_DELETE_FAIL = 'QUIZ_DELETE_FAIL'

export const QUIZ_UPDATE_REQUEST = 'QUIZ_UPDATE_REQUEST'
export const QUIZ_UPDATE_SUCCESS = 'QUIZ_UPDATE_SUCCESS'
export const QUIZ_UPDATE_FAIL = 'QUIZ_UPDATE_FAIL'
export const QUIZ_UPDATE_RESET = 'QUIZ_UPDATE_RESET'

